<template>
  <div class="path-editor">
    <TitleBar
      :name="modelValue.name"
      noun="Path"
      :entity-id="modelValue.id"
      id-prefix="path"
      @rename="$emit('rename', $event)"
      @duplicate="$emit('duplicate')"
      @delete="$emit('delete')"
      @update:entity-id="$emit('update:modelValue', { ...modelValue, id: $event })"
    >
      <template #tabs>
        <StSegmentedControl v-model="tab" :options="tabs" size="sm" on-shell />
      </template>
    </TitleBar>

    <div class="path-editor__pane">
      <PathForm
        v-if="tab === 'editor'"
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
      />
      <PathPreview v-else :path="modelValue" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { IPath } from '@scrolldex/shared';
import TitleBar from '../editor/TitleBar.vue';
import { StSegmentedControl, type SegmentOption } from '../ui/index.js';
import PathForm from './PathForm.vue';
import PathPreview from './PathPreview.vue';

defineProps<{ modelValue: IPath }>();
defineEmits<{
  (e: 'update:modelValue', value: IPath): void;
  (e: 'rename', next: string): void;
  (e: 'duplicate'): void;
  (e: 'delete'): void;
}>();

const tab = ref<string | number>('editor');
const tabs: SegmentOption[] = [
  { value: 'editor', label: 'Editor', icon: 'file-pen' },
  { value: 'preview', label: 'Preview', icon: 'eye' },
];
</script>

<style scoped>
.path-editor {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.path-editor__pane {
  padding: var(--st-space-3);
  overflow: auto;
}
</style>
